import { RowContainer, RowData, Cell } from './PricingTableRow.styles'

export type PricingTableRowData = {
	item_name?: string
	item_price?: string
}

type Props = {
	row: PricingTableRowData
}

const PricingTableRow = ({ row }: Props) => {
	if (!row) return null

	return (
		<RowContainer>
			<RowData>
				<Cell>{row.item_name || ''}</Cell>
				<Cell align='flex-end'>{row.item_price || ''}</Cell>
			</RowData>
		</RowContainer>
	)
}

export default PricingTableRow
